export function truncate(str: string, len: number) {
    return str.length > len ? str.slice(0, len) + "…" : str;
}

export function toDOSLineEndings(val: string) {
    return val.replace(/\n/g, "\r\n");
}

export function capitalize(str: string) {
    return str
        .split(" ")
        .map((s) => `${s[0]?.toUpperCase() || ""}${s.slice(1)}`)
        .join(" ");
}

export function pathToPascalCase(path: string) {
    return path
        .split("/")
        .filter(Boolean) // remove empty strings from consecutive '/'
        .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
        .join("");
}

export function escapeXML(str: string) {
    return str
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&apos;");
}